export const CRITERIA_SEARCHABLE = Symbol('CRITERIA_SEARCHABLE');

export const CRITERIA_ORDERABLE = Symbol('CRITERIA_ORDERABLE');

export const SEMICOLON = encodeURIComponent(';');
